import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function CheckboxMixed({ className }: Props) {
  return (
    <IconBase name="checkbox-mixed" w={24} className={className}>
      <rect x="4" y="4" width="16" height="16" rx="1" strokeWidth="2" fill="none"/>
      <line x1="9" y1="12" x2="15" y2="12" strokeWidth="2" strokeLinecap="round" fill="none"/>
    </IconBase>
  )
}

export default CheckboxMixed
